import React from 'react';
import { BLACK_60 } from '../constants/colors';

const DEFAULT_FONT_SIZE = 16;

const getFieldLabelStyle = (fontSize: number): React.CSSProperties => ({
  fontSize,
  lineHeight: '22px',
  color: BLACK_60,
});

type FieldLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  fontSize?: number;
};

export const FieldLabel = ({
  fontSize = DEFAULT_FONT_SIZE,
  style,
  children,
  ...rest
}: FieldLabelProps): JSX.Element => {
  return React.createElement(
    'label',
    { ...rest, style: { ...getFieldLabelStyle(fontSize), ...style } },
    children,
  ) as JSX.Element;
};

export const Label = FieldLabel;
